import React, { useState } from "react";
import { Box, Button, SpaceBetween, Popover } from "@cloudscape-design/components";
import { LABELS } from "../../constants";

interface TruncatedTextProps {
  text?: string;
  maxLength?: number;
}

export const TruncatedText: React.FC<TruncatedTextProps> = ({ text = "", maxLength = 300 }) => {
  const [copied, setCopied] = useState(false);
  const isTruncated = text.length > maxLength;
  const displayText = isTruncated ? `${text.slice(0, maxLength)}...` : text;

  const handleCopy = () => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <SpaceBetween size="xs">
      <div style={{ wordBreak: "break-word" }}>
        <Box variant="code" fontSize="body-s">
          {displayText}
        </Box>
      </div>
      {isTruncated && (
        <Popover
          content={copied ? LABELS.COPIED : "Copy full error"}
          dismissButton={false}
          position="top"
          size="small"
          triggerType="custom"
        >
          <Button iconName="copy" variant="inline-link" onClick={handleCopy}>
            Copy full error ({text.length} chars)
          </Button>
        </Popover>
      )}
    </SpaceBetween>
  );
};
